/*How to order page */

$(document).ready(function() {

      /* How to order page slide in animation on divs */

      $(function() {
        var $elements = $('.animate-block.not-animated');
        var $window = $(window);

        $elements.each(function(i, elem) {
          if ($(this).hasClass('animated'))
          return;
          animateMe($(this));
        });

        $window.on('scroll resize', function(e) {
          $elements.each(function(i, elem) {
            if ($(this).hasClass('animated'))
            return;
            animateMe($(this));
          });
        });
      });

      function animateMe(elem) {
        var winTop = $(window).scrollTop();
        var winBottom = winTop + $(window).height();
        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + (($(elem).height())/8);

        if ((elemBottom <= winBottom) && (elemTop >= winTop)) {
          $(elem).removeClass('notAnimated').addClass('animated');
        }
      }

});
